<template>
  <modal name="modal-view-note" height="auto" :width="560"
    :scrollable="true" :clickToClose="false" @closed="$emit('input', false)">
    <div v-if="note">
      <div class="border-bottom pb-1 mb-3">
        <h5><strong>{{ note.title }}</strong></h5>
        <div class="text-muted"><i class="fa fa-building"></i> {{ note.client?note.client.name:'No Name' }}</div>
      </div>
      <div v-html="note.content"></div>
      <div class="pt-2">
        <button type="button" class="btn btn-outline-secondary" @click="closeModal">Close</button>
      </div>
    </div>
  </modal>
</template>

<script>

export default {
  props: ['value', 'note'],
  watch: {
    value ( newVal ) {
      if ( newVal ) {
        this.$modal.show('modal-view-note', {});
      }
    }
  },
  methods: {
    closeModal () {
      this.$modal.hide('modal-view-note');
    },
  }
}
</script>
